<template>
  <SectionLayout
    id="advanced_setting"
    :class="{
      '!border-amber-300 border gem-meter-highlight__3rd-party': isHighlightGM,
    }"
    title="Advance Setting">
    <div class="advance__setting-body d-flex align-items-start">
      <PlanPermissionWrapper :click="() => {}" :permission-type="lazyLoadFeature">
        <template #default="{ disabled }">
          <Switcher
            v-if="!disabled"
            v-model:value="lazyLoad"
            padding="p-0"
            :inline="false"
            type="switch"
            custom
            :disabled="disabled">
            <div class="advance__setting-content d-flex flex-column ml-1">
              <span
                class="advance__setting-title text-light-high body-14-16-regular mb-1"
                :class="disabled ? 'text-light-disabled' : 'text-light-high'"
                >Enable Lazy Loading</span
              >
              <span
                class="advance__setting-desc body-12-regular"
                :class="disabled ? 'text-light-disabled' : 'text-light-low'">
                Improve your page loading speed by deferring image loads until they're actually needed.
              </span>
              <a
                target="_blank"
                href="https://help.gempages.net/articles/gempages-lazy-loading-guide"
                class="advance__setting-link text-mono3 body-12-regular"
                @click.stop>
                Learn more
              </a>
            </div>
          </Switcher>
          <div v-else class="advance__setting-content d-flex flex-column w-full">
            <div class="!mb-2 flex items-center justify-between">
              <span
                class="advance__setting-title text-light-high body-14-16-regular"
                :class="disabled ? 'text-light-disabled' : 'text-light-high'"
                >Lazy Loading</span
              >
              <a
                :href="pricingUrl"
                target="_blank"
                class="gp-open-new-tab cursor-pointer text-sm font-medium text-blue-300"
                >Upgrade to set up</a
              >
            </div>
            <span
              class="advance__setting-desc body-12-regular"
              :class="disabled ? 'text-light-disabled' : 'text-light-low'">
              Improve your page loading speed by deferring image loads until they're actually needed.
            </span>
            <a
              target="_blank"
              href="https://help.gempages.net/articles/gempages-lazy-loading-guide"
              class="advance__setting-link text-mono3 body-12-regular"
              @click.stop>
              Learn more
            </a>
          </div>
        </template>
      </PlanPermissionWrapper>
    </div>
  </SectionLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SectionLayout from './SectionLayout.vue';
import Toast from '@/core/components/base/Toast.vue';
import LazyLoadingUpdatePlan from './LazyLoadingUpdatePlan.vue';
import { mapGetters } from 'vuex';
import config from '@/app/editor/config';
import Switcher from '@/core/components/essenstials/Switcher.vue';
import { PlanPermissionWrapper, FEATURE_TYPES } from '@modules/common';
import goToPricing from '@/mixins/goToPricing';

/* eslint-disable vue/no-unused-components */
export default defineComponent({
  name: 'AdvanceSetting',
  components: {
    SectionLayout,
    LazyLoadingUpdatePlan,
    Toast,
    Switcher,
    PlanPermissionWrapper,
  },
  mixins: [goToPricing],
  props: {
    isHighlightGMProp: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    onLazyLoadThumbnail: `${config.domain()}${config.baseURL()}/images/page-setting/LazyLoadOn.svg`,
    offLazyLoadThumbnail: `${config.domain()}${config.baseURL()}/images/page-setting/LazyLoadOff.svg`,
    tooltipText: "Improve your page loading speed by deferring image loads until they're actually needed.",
    lazyLoadFeature: FEATURE_TYPES.LAZY_LOAD,
    isHighlightGM: false,
  }),

  computed: {
    ...mapGetters('app', {
      pagePlan: 'pagePlan',
    }),
    ...mapGetters('page', {
      defaultForm: 'advanceDefaultForm',
      currentForm: 'advanceForm',
    }),
    isStarter() {
      return this.pagePlan === 'starter';
    },
    lazyLoad: {
      get() {
        return this.currentForm.lazyLoad;
      },
      set(value: any) {
        (this as any).$store.commit('page/UPDATE_PAGE_SETTING_FORM', {
          tab: 'advance',
          field: 'lazyLoad',
          value,
        });
      },
    },
  },
  created() {
    if (this.isHighlightGMProp) {
      this.isHighlightGM = this.isHighlightGMProp;
      setTimeout(() => {
        this.isHighlightGM = false;
      }, 2500);
    }
  },
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.advance__setting {
  &-link {
    cursor: pointer;
    width: max-content;
  }
  &-content {
    .disabled {
      color: $text-light-disabled;
    }
  }
  &-toggler {
    flex: 0 0 34px;
  }
}
</style>
